import React, {
    PureComponent
} from 'react';
import Loader from 'react-loader-spinner'
import { withRouter } from 'react-router-dom';
import { Row, Col, Panel, PanelGroup, Timeline, Button, ButtonToolbar } from 'rsuite';
//  import {PoProductsDataElements} from '../../dataComponentsTrans/PoProductsDataElements';
//  import RTable from '../../componentsGeneral/Rsuite/Table/RTable';
import { formatNumberForAPI, isNumeric, formatStringForAPI, replaceNegativeWithZero } from '../../../resources/logic/functions';
import LoadPoDataElements from '../../dataComponentsTrans/LoadPoDataElements';

import RTable from '../../componentsGeneral/Rsuite/Table/RTable';
import ReactExport from "react-export-excel";
import * as moment from 'moment'
import AddToLoadDrawer from './AddToLoadDrawer';
import AddNewModal from './AddNewModal';
import EditLoadDrawer from './EditLoadDrawer';
import LoadExportModal from '../LoadExport/LoadExportModal';
import RemoveFromLoadModal from '../PoDetails/RemoveFromLoadModal';

//For excel export
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
var currentDateTime = moment().format("_YYYY-MM-DDTHH-mm-ss")


const tableIdCol = "PoID"

//For Rsuite NavBar
const styles = {
    marginBottom: 50
};


class LoadDetails extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

            //Edit Load Drawer
            showEditLoadDrawer: false,
            editLoadItem: {},
            unsavedEditLoadChanges: false,


            //Build Load Drawer
            showBuildLoadDrawer: false,
            item: {},
            PoSearch: null,
            ContainerSearch: null,
            addNewModalShown: false,

            LocationDict: {},

            //Export Modal
            isModalShown: false,
            loadDataExportModal: {},

            //Remove From Load Modal
            removeFromModalShown: false,
            removeFromLoadRowData: {}

        };
        // Table Sort
        this.handleSortColumn = this.handleSortColumn.bind(this);
        this.handleSortColumnDrawer = this.handleSortColumnDrawer.bind(this);

        // this.onClickEditRecovery = this.onClickEditRecovery.bind(this);
        this.onClickClearCustoms = this.onClickClearCustoms.bind(this);
        this.onClickRemoveFromLoad = this.onClickRemoveFromLoad.bind(this);

        //Edit Load Drawer
        this.onChangeEditLoadDrawer = this.onChangeEditLoadDrawer.bind(this);
        this.onClickSaveEditLoadDrawer = this.onClickSaveEditLoadDrawer.bind(this);
        this.openEditLoadDrawer = this.openEditLoadDrawer.bind(this);
        this.closeEditLoadDrawer = this.closeEditLoadDrawer.bind(this);

        //Build Load Drawer
        this.onChangeBuildLoadDrawer = this.onChangeBuildLoadDrawer.bind(this);
        this.onClickAddToLoad = this.onClickAddToLoad.bind(this);
        this.closeBuildLoadDrawer = this.closeBuildLoadDrawer.bind(this);
        this.onClickAdd = this.onClickAdd.bind(this);
        this.onClickSearch = this.onClickSearch.bind(this);
        this.onClickReset = this.onClickReset.bind(this);
        this.handleOpenAddNewModal = this.handleOpenAddNewModal.bind(this);
        this.handleCloseAddNewModal = this.handleCloseAddNewModal.bind(this);
        this.handleSaveAddNewModal = this.handleSaveAddNewModal.bind(this);
        this.onChangeExistingBuildLoadDrawer = this.onChangeExistingBuildLoadDrawer.bind(this);
        this.onChangeLocation = this.onChangeLocation.bind(this)

        //Export Modal
        this.onClickExportLoad = this.onClickExportLoad.bind(this);
        this.handleCloseExportModal = this.handleCloseExportModal.bind(this);


        //Delete Load
        this.onClickDeleteLoad = this.onClickDeleteLoad.bind(this);

        //Remove From Load Modal
        this.handleOpenRemoveFromLoadModal = this.handleOpenRemoveFromLoadModal.bind(this);
        this.handleCloseRemoveFromLoadModal = this.handleCloseRemoveFromLoadModal.bind(this);
        this.handleSaveRemoveFromLoadModal = this.handleSaveRemoveFromLoadModal.bind(this);



        //Add to load
        this.onClickRemoveFromAdd = this.onClickRemoveFromAdd.bind(this)
    }





    handleSortColumn(sortColumn, sortType) {
        this.setState({
            loading: true
        });

        setTimeout(() => {
            this.setState({
                sortColumn,
                sortType,
                loading: false
            });
        }, 500);
    }
    handleSortColumnDrawer(sortColumnDrawer, sortTypeDrawer) {
        this.setState({
            loading: true
        });

        setTimeout(() => {
            this.setState({
                sortColumnDrawer,
                sortTypeDrawer,
                loading: false
            });
        }, 500);
    }


    onClickClearCustoms(e) {
        if (typeof (this.props.warehouseSelection) === 'number' && typeof (this.props.customerSelection) === 'number') {
            if (window.confirm('Clear Customs?')) {
                this.props.hawbRecoveryPost(
                    this.props.currentUserEmail,
                    this.props.userSignInData.AuthToken,
                    null,
                    formatNumberForAPI(this.props.LoadData[0].PoID),
                    null,
                    null,
                    null,
                    null,
                    1,
                    this.props.warehouseSelection,
                    this.props.customerSelection
                )
            }
        }
        else { window.alert('Please select only one Warehouse and one Customer to save data.') }
    }

    //On Click Details
    onClickDetails(e, rowData, history) {
        try {
            var paramID = rowData["PoID"]
            history.push({
                pathname: 'podetails',
                search: 'poid=\'' + paramID + '\''
            });
        }
        catch (e) {
        }
    }

    onClickRemoveFromLoad(rowData, keyColumn) {

        this.props.transPoLoadLocationHistoryGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, rowData["LoadID"], rowData["PoID"], null)

        this.handleOpenRemoveFromLoadModal(rowData)

        // if (window.confirm('Remove from load?')) {
        //     // this.props.transLoadRemovePost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, rowData["LoadID"], rowData["PoID"], rowData["PCS"], rowData["Pallets"], null /* this is new json with location */ , this.props.warehouseSelection, this.props.customerSelection)
        // }
    }






    onClickAddToLoad(e) {
        var buildLoadArray = {};
        buildLoadArray = this.props.PoData

        var newLoadDict = {}
        newLoadDict['PoSearch'] = null
        newLoadDict['ContainerSearch'] = null

        for (let k in buildLoadArray) {
            // buildLoadArray[k]['NewCasesReceived'] = buildLoadArray[k]['CasesReceived'] - buildLoadArray[k]['CasesLoaded']
            buildLoadArray[k]['NewCasesReceived'] = buildLoadArray[k]['InWarehouseCases']
            // buildLoadArray[k]['NewPallets'] = replaceNegativeWithZero(buildLoadArray[k]['PalletsReceived'] - buildLoadArray[k]['PalletsLoaded'])
            buildLoadArray[k]['NewPallets'] = replaceNegativeWithZero(buildLoadArray[k]['InWarehousePallets'])
        }
        this.setState({
            BuildLoadDict: buildLoadArray,
            showBuildLoadDrawer: true,
        });
    }









    //Edit Load Drawer
    openEditLoadDrawer(e) {
        var editLoadData = {}
        // editLoadData = this.props.LoadData[0]

        editLoadData['LoadID'] = this.props.LoadData[0].LoadID
        editLoadData['PickupDate'] = this.props.LoadData[0].PickupDate
        editLoadData['DeliveryDate'] = this.props.LoadData[0].DeliveryDate
        editLoadData['Carrier'] = this.props.LoadData[0].Carrier
        editLoadData['BOL'] = this.props.LoadData[0].BOL
        editLoadData['Trailer'] = this.props.LoadData[0].Trailer
        editLoadData['Seal'] = this.props.LoadData[0].Seal
        editLoadData['Destination'] = this.props.LoadData[0].DestinationID

        this.setState({
            unsavedEditLoadChanges: false,
            editLoadItem: editLoadData,
            showEditLoadDrawer: true
        });
    }

    onChangeEditLoadDrawer(event, label) {
        var currentLoadData = {}
        currentLoadData = this.state.editLoadItem
        currentLoadData[label] = event
        this.setState({
            unsavedEditLoadChanges: true,
            editLoadItem: currentLoadData
        });
        this.forceUpdate()
    }

    onClickSaveEditLoadDrawer(e) {
        if (typeof (this.props.warehouseSelection) === 'number' && typeof (this.props.customerSelection) === 'number') {

            try {
                var paramPostLoadID = this.state.editLoadItem.LoadID
            }
            catch (e) {
                var paramPostLoadID = null
            }

            try {
                if (this.state.editLoadItem.PickupDate != null) {
                    var paramPostPickupDate = "'" + moment(this.state.editLoadItem.PickupDate).format('YYYY-MM-DD') + "'"
                }
                else {
                    var paramPostPickupDate = null
                }
            }
            catch (e) {
                var paramPostPickupDate = null
            }
            try {
                if (this.state.editLoadItem.DeliveryDate != null) {
                    var paramPostDeliveryDate = "'" + moment(this.state.editLoadItem.DeliveryDate).format('YYYY-MM-DD') + "'"
                }
                else {
                    var paramPostDeliveryDate = null
                }
            }
            catch (e) {
                var paramPostDeliveryDate = null
            }
            try {
                var paramPostCarrier = formatStringForAPI(this.state.editLoadItem.Carrier)
            }
            catch (e) {
                var paramPostCarrier = null
            }
            try {
                var paramPostBOL = formatStringForAPI(this.state.editLoadItem.BOL)
            }
            catch (e) {
                var paramPostBOL = null
            }
            try {
                var paramPostTrailer = formatStringForAPI(this.state.editLoadItem.Trailer)
            }
            catch (e) {
                var paramPostTrailer = null
            }
            try {
                var paramPostSeal = formatStringForAPI(this.state.editLoadItem.Seal)
            }
            catch (e) {
                var paramPostSeal = null
            }
            try {
                var paramPostDesintation = formatStringForAPI(this.state.editLoadItem.Destination)
            }
            catch (e) {
                var paramPostDesintation = null
            }


            this.props.transLoadPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, paramPostLoadID, paramPostPickupDate, paramPostDeliveryDate, paramPostCarrier, paramPostBOL, paramPostTrailer, paramPostSeal, null, null, paramPostDesintation, null, null, null, null, null, null, this.props.warehouseSelection, this.props.customerSelection)

            this.setState({
                showEditLoadDrawer: false,
                unsavedEditLoadChanges: false,
                editLoadItem: {}
            });
        }
        else { window.alert('Please select only one Warehouse and one Customer to save data.') }
    }

    closeEditLoadDrawer(e) {
        if (this.state.unsavedEditLoadChanges) {
            if (window.confirm('Leave without saving changes?')) {
                this.setState({
                    showEditLoadDrawer: false,
                    unsavedEditLoadChanges: false,
                    editLoadItem: {}
                });
            }
        }
        else {
            this.setState({
                showEditLoadDrawer: false,
                unsavedEditLoadChanges: false,
                editLoadItem: {}
            });
        }
    }











    //Build Load Drawer
    onClickBuildLoad(e) {

        this.setState({
            showBuildLoadDrawer: true
        });

    }
    onChangeBuildLoadDrawer = (event, label) => {

        var poState = null
        if (label == 'PoSearch') {
            poState = event
        }
        var containerState = null
        if (label == 'ContainerSearch') {
            containerState = event
        }

        this.setState({
            PoSearch: poState,
            ContainerSearch: containerState

        });

    };


    onClickAdd(e, item) {
        var poID = item['PoID']
        var PoLocationDataGrouped = JSON.parse(JSON.stringify(this.props.PoLocationDataGrouped));

        var newLocationDict = Object.keys(PoLocationDataGrouped).
            filter((key) => poID === (Number(key))).
            reduce((cur, key) => { return Object.assign(cur, { [key]: PoLocationDataGrouped[key] }) }, {});

        var newItem = {};
        newItem = item

        try {
            newItem['NewCasesReceived'] = replaceNegativeWithZero((newLocationDict[newItem['PoID']].reduce((a, v) => a = a + v.Cases, 0)))
            newItem['NewPallets'] = replaceNegativeWithZero((newLocationDict[newItem['PoID']].reduce((a, v) => a = a + v.Pallets, 0)))
        }
        catch (e) {
            // newItem['NewCasesReceived'] = replaceNegativeWithZero(item['CasesReceived'] - item['CasesLoaded'])
            // newItem['NewPallets'] = replaceNegativeWithZero(item['PalletsReceived'] - item['PalletsLoaded'])
            newItem['NewCasesReceived'] = replaceNegativeWithZero(item['InWarehouseCases'])
            newItem['NewPallets'] = replaceNegativeWithZero(item['InWarehousePallets'])
        }

        this.setState({
            LocationDict: newLocationDict,
            item: newItem
        });
        this.handleOpenAddNewModal()
    }

    closeBuildLoadDrawer() {
        this.setBuildLoadDrawerToClose()
    }

    setBuildLoadDrawerToClose() {
        this.setState({
            LocationDict: {},
            showBuildLoadDrawer: false
            // item: {}
        });
    }



    onClickSearch(e, searchType) {
        if (searchType == 'PoSearch') {
            this.setState({
                ContainerSearch: null,
                item: {}
            });
            this.props.transPoLocationGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken, null, null, null, null, null, null, null, formatStringForAPI(this.state.PoSearch), null, null, null, null, this.props.warehouseSelection, this.props.customerSelection)
            this.props.transPoGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, null, null, null, null, null, null, null, formatStringForAPI(this.state.PoSearch), null, null, null, null, null, null);
        }
        else if (searchType == 'ContainerSearch') {
            this.setState({
                PoSearch: null,
                item: {}
            });
            this.props.transPoLocationGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken, null, formatStringForAPI(this.state.ContainerSearch), null, null, null, null, null, null, null, null, null, null, this.props.warehouseSelection, this.props.customerSelection)
            this.props.transPoGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, null, formatStringForAPI(this.state.ContainerSearch), null, null, null, null, null, null, null, null, null, null, null, null);
        }
    }


    onClickReset(e, searchType) {
        this.setState({
            PoSearch: null,
            ContainerSearch: null,
            item: {},
            LocationDict: {},
        });
        this.props.transPoGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, null, null, null, null, null, null, null, null, null, 1, null, null, null, null);
    }


    handleOpenAddNewModal() {
        this.setState({
            addNewModalShown: true
        });
    }
    handleCloseAddNewModal() {
        this.setState({
            addNewModalShown: false
        });
    }


    onChangeExistingBuildLoadDrawer = (event, item, label) => {
        var existingItem = this.state.item

        existingItem[label] = isNumeric(event)

        this.setState({
            item: existingItem
        });
    };

    onChangeLocation = (e, locationitem, label, warehouseLocationID) => {

        var poId = this.state.item.PoID;
        var itemIndex = this.state.LocationDict[poId].findIndex(({ WarehouseLocationID }) => WarehouseLocationID === warehouseLocationID);
        var newLocationBuildDict = this.state.LocationDict

        newLocationBuildDict[poId][itemIndex][label] = isNumeric(e)

        // var currentBuildLoadDictIndex = this.state.BuildLoadDict.findIndex(({ PoID }) => PoID === poId);
        var currentBuildLoadDict = this.state.item

        try {
            currentBuildLoadDict['NewCasesReceived'] = replaceNegativeWithZero((newLocationBuildDict[poId].reduce((a, v) => a = a + v.Cases, 0)))
            currentBuildLoadDict['NewPallets'] = replaceNegativeWithZero((newLocationBuildDict[poId].reduce((a, v) => a = a + v.Pallets, 0)))
        }
        catch (e) {
            currentBuildLoadDict['NewCasesReceived'] = replaceNegativeWithZero(currentBuildLoadDict['InWarehouseCases'])
            currentBuildLoadDict['NewPallets'] = replaceNegativeWithZero(currentBuildLoadDict['InWarehousePallets'])
        }

        this.setState({
            // unsavedBuildLoadChanges: true,
            item: currentBuildLoadDict,
            LocationDict: newLocationBuildDict,
        });

        this.forceUpdate()
    }

    onClickRemoveFromAdd = (e, locationitem, warehouseLocationID) => {
        var currentList = JSON.parse(JSON.stringify(this.state.LocationDict));

        var poID = this.state.item.PoID

        var remainingItems = currentList[poID].filter((item) => { return item.WarehouseLocationID !== warehouseLocationID });

        currentList[poID] = JSON.parse(JSON.stringify(remainingItems));
        var currentBuildLoadDict = this.state.item

        try {
            currentBuildLoadDict['NewCasesReceived'] = replaceNegativeWithZero((currentList[poID].reduce((a, v) => a = a + v.Cases, 0)))
            currentBuildLoadDict['NewPallets'] = replaceNegativeWithZero((currentList[poID].reduce((a, v) => a = a + v.Pallets, 0)))
        }
        catch (e) {
            currentBuildLoadDict['NewCasesReceived'] = replaceNegativeWithZero(currentBuildLoadDict['CasesReceived'] - currentBuildLoadDict['CasesLoaded'])
            currentBuildLoadDict['NewPallets'] = replaceNegativeWithZero(currentBuildLoadDict['PalletsReceived'] - currentBuildLoadDict['PalletsLoaded'])
        }

        this.setState({
            // unsavedBuildLoadChanges: true,
            item: currentBuildLoadDict,
            LocationDict: currentList,
        });

        this.forceUpdate()
    }

    handleSaveAddNewModal() {
        if (typeof (this.props.warehouseSelection) === 'number' && typeof (this.props.customerSelection) === 'number') {

            const currentListLocation = this.state.LocationDict

            var newLocationToPost = []
            for (let x in currentListLocation) {
                for (let i in currentListLocation[x]) {
                    try {
                        newLocationToPost.push({ 'PoID': isNumeric(x), 'WarehouseLocationID': currentListLocation[x][i]['WarehouseLocationID'], 'Cases': currentListLocation[x][i]['Cases'], 'Pallets': currentListLocation[x][i]['Pallets'] })
                    }
                    catch (e) { }
                }
            }
            var locationString = JSON.stringify(newLocationToPost)
            try {
                var paramPostLocationPoData = "'" + locationString + "'"
            }
            catch (e) {
                var paramPostLocationPoData = null
            }


            this.props.transLoadPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.LoadData[0].LoadID, null, null, null, null, null, null, null, null, null, null, null, paramPostLocationPoData, this.state.item.PoID, this.state.item.NewCasesReceived, this.state.item.NewPallets, this.props.warehouseSelection, this.props.customerSelection)

            this.handleCloseAddNewModal()

            this.setBuildLoadDrawerToClose()
        }
        else { window.alert('Please select only one Warehouse and one Customer to save data.') }
    }



    //Export Modal
    onClickExportLoad(e) {
        this.setState({
            loadDataExportModal: this.props.LoadData[0],
            isModalShown: true
        });

    }
    handleCloseExportModal() {
        this.setState({
            isModalShown: false
        });
    }


    //Delete Load
    onClickDeleteLoad(e) {
        if (typeof (this.props.warehouseSelection) === 'number' && typeof (this.props.customerSelection) === 'number') {

            if (this.props.LoadPoData.length > 0) {
                window.alert('Please first remove all POs from Load')
            }
            else if (window.confirm('Are you sure you want to delete this load?')) {
                this.props.transLoadPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.LoadData[0].LoadID, null, null, null, null, null, null, null, null, null, 4, null, null, null, null, null, this.props.warehouseSelection, this.props.customerSelection)
            }
        }
        else { window.alert('Please select only one Warehouse and one Customer to save data.') }

    }

    //Depart Load
    onClickDepartLoad(e) {
        if (typeof (this.props.warehouseSelection) === 'number' && typeof (this.props.customerSelection) === 'number') {

            if (this.props.LoadData[0].Trailer === null || this.props.LoadData[0].Trailer == 'null') {
                window.alert('Please enter Trailer.')
            }
            else if (this.props.LoadData[0].Carrier === null || this.props.LoadData[0].Carrier == 'null') {
                window.alert('Please enter Carrier.')
            }
            else if (this.props.LoadData[0].BOL === null || this.props.LoadData[0].BOL == 'null') {
                window.alert('Please enter BOL.')
            }
            else if (this.props.LoadData[0].Seal === null || this.props.LoadData[0].Seal == 'Seal') {
                window.alert('Please enter Seal.')
            }
            else if (window.confirm('Depart Load?')) {
                this.props.transLoadPost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.LoadData[0].LoadID, null, null, null, null, null, null, null, null, null, 2, null, null, null, null, null, this.props.warehouseSelection, this.props.customerSelection)
            }
        }
        else { window.alert('Please select only one Warehouse and one Customer to save data.') }
    }


    //Remove from load modal
    handleOpenRemoveFromLoadModal(rowData) {
        this.setState({
            removeFromModalShown: true,
            removeFromLoadRowData: rowData
        });
    }
    handleCloseRemoveFromLoadModal() {
        this.setState({
            removeFromModalShown: false,
            removeFromLoadRowData: {}
        });
    }
    handleSaveRemoveFromLoadModal() {
        if (typeof (this.props.warehouseSelection) === 'number' && typeof (this.props.customerSelection) === 'number') {


            const currentListLocation = this.props.PoLoadLocationHistoryData

            var newLocationToPost = []
            for (let x in currentListLocation) {
                try {
                    newLocationToPost.push({ 'PoID': isNumeric(currentListLocation[x]["PoID"]), 'WarehouseLocationID': currentListLocation[x]['WarehouseLocationID'], 'Cases': currentListLocation[x]['NetCases'], 'Pallets': currentListLocation[x]['NetPallets'] })
                }
                catch (e) { }
            }
            var locationString = JSON.stringify(newLocationToPost)
            try {
                var paramPostLocationPoData = "'" + locationString + "'"
            }
            catch (e) {
                var paramPostLocationPoData = null
            }

            if (this.props.PoLoadLocationHistoryData.length === 0) {
                paramPostLocationPoData = null
            }

            this.props.transLoadRemovePost(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.state.removeFromLoadRowData["LoadID"], this.state.removeFromLoadRowData["PoID"], this.state.removeFromLoadRowData["PCS"], this.state.removeFromLoadRowData["Pallets"], paramPostLocationPoData, this.props.warehouseSelection, this.props.customerSelection)

            this.handleCloseRemoveFromLoadModal()
        }
        else { window.alert('Please select only one Warehouse and one Customer to save data.') }
    }



    render() {

        const { sortColumn, sortType, sortColumnDrawer, sortTypeDrawer } = this.state;

        let pageHeader;
        let detailsDiv;
        let editLoadDrawerDiv;
        let houseButtonDiv;
        if (this.props.isLoadLoading) {
            houseButtonDiv = <div></div>
            editLoadDrawerDiv = <div></div>
            detailsDiv =
                <div align="center">
                    <section className="panel">
                    </section>
                    <Loader
                        type="TailSpin"
                        color="#3396E5"
                        height="50"
                        width="50"
                    />
                </div>
        }
        else if (typeof (this.props.LoadData[0]) !== 'undefined' && this.props.LoadData != null) {

            var currentLoadStatus = this.props.LoadData[0].CurrentLoadStatusID




            houseButtonDiv = currentLoadStatus != 4 ? <Row>
                Po List
                <Button onClick={(e) => { this.onClickAddToLoad(e) }} style={{ float: 'right' }}> Add to Load </Button>
            </Row> : <div></div>

            editLoadDrawerDiv = <EditLoadDrawer {...this.props} state={this.state}
                onChange={this.onChangeEditLoadDrawer}
                onClickSave={this.onClickSaveEditLoadDrawer}
                close={this.closeEditLoadDrawer}
            />

            pageHeader = 'Transload - Load Details'
            detailsDiv =
                <div>
                    <Row >

                        <Col md={24} sm={24}>
                            <Panel bordered style={{ marginBottom: 10 }} header={currentLoadStatus != 4 ? <ButtonToolbar style={{ float: 'right' }}>  {this.props.LoadData[0].CurrentLoadStatusID == 1 ? <Button onClick={(e) => { this.onClickDepartLoad(e) }}>Depart Load</Button> : ''}  <Button onClick={(e) => { this.openEditLoadDrawer(e) }} > Edit Load </Button> <Button onClick={(e) => { this.onClickExportLoad(e) }} > Manifest </Button></ButtonToolbar> : ''} >
                                Carrier: <strong>{this.props.LoadData[0].Carrier}</strong>
                                <br />
                                Trailer: <strong>{this.props.LoadData[0].Trailer}</strong>
                                <br />
                                BOL: <strong>{this.props.LoadData[0].BOL}</strong>
                                <br />
                                Seal: <strong>{this.props.LoadData[0].Seal}</strong>
                                <br />
                                {/* Consignee: <strong>{this.props.LoadData[0].ConsigneeName}</strong> */}
                                {/* <br /> */}
                                Destination: <strong>{this.props.LoadData[0].Destination}</strong>
                                <br />
                                Load Status: <strong>{this.props.LoadData[0].LoadStatusName}</strong>
                                <br />

                                {currentLoadStatus != 4 ? <ButtonToolbar style={{ float: 'right', marginBottom: '15px' }}><Button onClick={(e) => { this.onClickDeleteLoad(e) }} > Delete Load </Button></ButtonToolbar> : ''}
                            </Panel>
                        </Col>
                    </Row>

                    <Row >
                        <Col md={12} sm={24}>
                            <Panel bordered style={{ marginBottom: 10 }}>
                                Total PCS: <strong>{this.props.LoadData[0].TotalPCS}</strong>
                                <br />
                                Total Pallets: <strong>{this.props.LoadData[0].TotalPallets}</strong>
                                <br />

                            </Panel>
                        </Col>
                        <Col md={12} sm={24}>
                            <Panel bordered style={{ marginBottom: 10 }}>

                                Pickup Date: <strong>{this.props.LoadData[0].PickupDate}</strong>
                                <br />

                                Delivery Date: <strong>{this.props.LoadData[0].DeliveryDate}</strong>
                                <br />


                            </Panel>
                        </Col>
                    </Row>
                </div>

        }
        else {
            detailsDiv = <div></div>;
            editLoadDrawerDiv = <div></div>;
            houseButtonDiv = <div></div>
        }





        let loadDiv;
        let rTable;
        if (this.props.isLoadPoLoading) {
            rTable = <div></div>
            loadDiv =
                <div align="center">
                    <section className="panel">
                    </section>
                    <Loader
                        type="TailSpin"
                        color="#3396E5"
                        height="50"
                        width="50"
                    />
                </div>
        }
        else if (typeof (this.props.LoadPoData) !== 'undefined' && this.props.LoadPoData != null) {

            if (this.props.LoadPoData.length === 0) {
                rTable = <div></div>
                loadDiv = <div></div>
            }
            else {

                // let rTable;
                rTable = RTable(
                    this.props.LoadPoData,        // tableData,
                    LoadPoDataElements,  // DataElements,
                    sortColumn,                 // sortColumn,
                    sortType,                   // sortType,
                    this.props.isLoadPoLoading,         // loading,
                    this.handleSortColumn,      // handleSortColumn,
                    this.onClickDetails,        // onClickDetails,
                    false,                      // checkColEntry,
                    tableIdCol,                 // keyColumn,
                    null,                       // checkedKeys,
                    null,                       // handleCheckAll,
                    null,                       // handleCheck,
                    // false,                      // boolSelectButton,
                    false,
                    null,
                    // this.onClickReceive,     // onClickSelect,
                    'Receive',                       // selectButtonText,
                    this.props.isMobile,        // isMobile,
                    this.props.history,         // history,
                    null,                        // highlightRowKey

                    true,// editLink,
                    'Remove', // editLinkText,
                    this.onClickRemoveFromLoad// editLinkOnClick
                )

                loadDiv = <div>


                    {(this.props.isMobile == true) ? <div></div> :
                        <div>
                            <Row>
                                <ExcelFile element={<Button >Export Excel</Button>} filename={'PO_' + currentDateTime}>
                                    <ExcelSheet data={this.props.LoadPoData} name="PO">

                                        {
                                            LoadPoDataElements.map(
                                                ({ dBKey, displayName }, idx) => {
                                                    return (
                                                        <ExcelColumn label={displayName} value={dBKey} />
                                                    );
                                                }
                                            )
                                        }

                                    </ExcelSheet>
                                </ExcelFile>
                            </Row>
                        </div>
                    }

                </div>
            }
        }
        else {
            rTable = <div></div>
            loadDiv = <div></div>
        }



        let loadTimeline;
        if (this.props.isLoadPoHistoryLoading) {
            loadTimeline =
                <div align="center">
                    <section className="panel">
                    </section>
                    <Loader
                        type="TailSpin"
                        color="#3396E5"
                        height="50"
                        width="50"
                    />
                </div>
        }
        else if (typeof (this.props.LoadPoHistoryData[0]) !== 'undefined' && this.props.LoadPoHistoryData != null) {
            loadTimeline =
                <div>
                    <Panel header="Load Events" bordered style={{ marginBottom: 10 }}>
                        <Timeline>
                            {this.props.LoadPoHistoryData.map(item => (
                                <Timeline.Item>
                                    {item.LoadPoDT}  &nbsp;
                                    {item.EmailAddr}
                                    {item.PO != null ? <l><br /> PO:  {item.PO} </l> : ' '}
                                    {item.PCS != 0 ? <l><br /> PCS:  {item.PCS} </l> : ' '}
                                    {item.Pallets != 0 ? <l><br /> Pallets:  {item.Pallets} </l> : ' '}
                                    {item.Notes != null ? <l><br /> Notes:  {item.Notes} </l> : ' '}
                                </Timeline.Item>
                            ))}
                        </Timeline>
                    </Panel>
                </div>
        }


        let buildLoadDrawer;
        if (this.props.isPoLoading) {
            buildLoadDrawer = <div align="center">
                <section className="panel">
                </section>
                <Loader
                    type="TailSpin"
                    color="#3396E5"
                    height="50"
                    width="50"
                />
            </div>
        }
        else if (typeof (this.state.BuildLoadDict) !== 'undefined' && this.state.BuildLoadDict != null && this.state.BuildLoadDict.length > 0 && this.state.showBuildLoadDrawer) {
            buildLoadDrawer = <AddToLoadDrawer {...this.props} state={this.state}
                onClickAdd={this.onClickAdd}
                onChange={this.onChangeBuildLoadDrawer}
                close={this.closeBuildLoadDrawer}
                handleSortColumn={this.handleSortColumnDrawer}
                sortColumn={this.state.sortColumnDrawer}
                sortType={this.state.sortTypeDrawer}
                onClickSearch={this.onClickSearch}
                onClickReset={this.onClickReset}
                tableIdCol={tableIdCol}
            />
        }


        let addNewModalDiv;
        if (!this.state.addNewModalShown) {
            addNewModalDiv = <div></div>
        }
        else if (this.props.isPoLocationLoading) {
            addNewModalDiv = <div></div>
        }
        else {
            addNewModalDiv = <AddNewModal {...this.props} state={this.state} addNewModalShown={this.state.addNewModalShown} onChangeExisting={this.onChangeExistingBuildLoadDrawer} onChangeLocation={this.onChangeLocation} onClickRemoveFromAdd={this.onClickRemoveFromAdd} handleOpen={this.handleOpenAddNewModal} handleClose={this.handleCloseAddNewModal} handleSave={this.handleSaveAddNewModal} />
        }

        let removeFromLoadModalDiv;
        if (!this.state.removeFromModalShown) {
            removeFromLoadModalDiv = <div></div>
        }
        else if (this.props.isPoLoadLocationHistoryLoading) {
            removeFromLoadModalDiv = <div></div>
        }
        else {
            removeFromLoadModalDiv = <RemoveFromLoadModal {...this.props} state={this.state} titlePO={this.state.removeFromLoadRowData["PO"]} removeFromModalShown={this.state.removeFromModalShown} onChangeExisting={this.onChangeExistingBuildLoadDrawer} onChangeLocation={this.onChangeLocation} handleOpen={this.handleOpenRemoveFromLoadModal} handleClose={this.handleCloseRemoveFromLoadModal} handleSave={this.handleSaveRemoveFromLoadModal} />
        }


        return (
            <div>
                <h3>
                    {pageHeader}
                </h3>

                <PanelGroup>

                    {detailsDiv}

                </PanelGroup>



                <Panel header={houseButtonDiv} bordered style={{ marginBottom: 10 }}>
                    {loadDiv}
                    {rTable}
                </Panel>

                {loadTimeline}


                {buildLoadDrawer}
                {editLoadDrawerDiv}
                {addNewModalDiv}
                <LoadExportModal {...this.props} state={this.state}
                    isModalShown={this.state.isModalShown}
                    handleClose={this.handleCloseExportModal}
                />

                {removeFromLoadModalDiv}
            </div>
        );
    }
}

export default withRouter(LoadDetails);

